import React, { Fragment } from 'react';
import T from 'prop-types';

import PerformanceWidget from './PerformanceWidget';
import MainSideLayout from '../../_shared/components/MainSideLayout';

const ComparisonSummary = ({ header, description, apps, isMobileView }) => (
  <MainSideLayout
    mainContent={
      <Fragment>
        <h1 className="comparison-title h1">{header}</h1>
        <div
          className="comparison-description"
          dangerouslySetInnerHTML={{
            __html: description,
          }}
        />
      </Fragment>
    }
    sideContent={<PerformanceWidget data={apps} isMobileView={isMobileView} />}
    className="comparison-summary"
  />
);

ComparisonSummary.propTypes = {
  header: T.string.isRequired,
  description: T.string.isRequired,
  apps: T.array.isRequired,
  isMobileView: T.bool.isRequired,
};

export default ComparisonSummary;
